const modal = document.querySelector('.entry-disclaimer-popup');
const closeBtn = modal.querySelector('button[data-close-modal]');

const hasDisclaimerCookie = () => {
  return document.cookie.split('; ').find(row => row.startsWith('entry_disclaimer_accepted'));
}

const setCookie = (cname, cvalue, exdays) => {
  if (!hasDisclaimerCookie()) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
}

const triggerDataLayerEvent = () => {
  if (window.dataLayer.find((event) => event.event === 'entryDisclaimerAccepted')) return;
  window.dataLayer.push({
    'event': 'entryDisclaimerAccepted'
  });
}

const closeModal = (modal) => {
  setCookie('entry_disclaimer_accepted', 'true', 730);
  triggerDataLayerEvent();
  modal.close();
  document.body.classList.remove('entry-disclaimer-show');
};

const maybeShowModal = (modal) => {
  if (!hasDisclaimerCookie()) {
    document.body.classList.add('entry-disclaimer-show');
    modal.showModal();
  }
}

closeBtn.addEventListener('click', function (event) {
  event.preventDefault();
  closeModal(modal);
});

modal.addEventListener('click', (target) => {
  const dialogDimensions = modal.getBoundingClientRect();
  if (
    target.clientX < dialogDimensions.left ||
    target.clientX > dialogDimensions.right ||
    target.clientY < dialogDimensions.top ||
    target.clientY > dialogDimensions.bottom
  ) {
    closeModal(modal);
  }
});

maybeShowModal(modal);